import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import VerticalNavLink from '../verticalNavLink';

function MAListJobsMediaExchange({ onActive, handleDrawerToggle }) {
    return (
        <List disablePadding>
            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/media-exchange/media-exchange-web-server'}
                onClick={handleDrawerToggle}
                secondary={'Web Server Settings'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/media-exchange/media-gateway-guide'}
                onClick={handleDrawerToggle}
                secondary={'Media Gateway Guide'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/media-exchange/media-exchange-channels'}
                onClick={handleDrawerToggle}
                secondary={'Media Exchange Channels'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/media-exchange/dropbox-monitor'}
                onClick={handleDrawerToggle}
                secondary={'Dropbox Monitor Jobs'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/media-exchange/dropbox-monitor/packages'}
                onClick={handleDrawerToggle}
                secondary={'Managing Packages'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/media-exchange/media-exchange-configuration'}
                onClick={handleDrawerToggle}
                secondary={'Configuration'}
            />
        </List>
    );
}

MAListJobsMediaExchange.propTypes = {
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default MAListJobsMediaExchange;
